<a [routerLink]="link" class="capacity-container">
  <div class="capacity-icon">
    <i [class]="icon"></i>
  </div>
  <div class="capacity-info">
    <h3 class="capacity-title">{{ title }}</h3>
    <p class="capacity-description">{{ description }}</p>
  </div>
</a>
